export const incomingRequests = {

  "title": "Έξυπνο ταίριασμα",
  "subtitle": "Ανακαλύψτε μέλη που θέλουν να επισκεφτούν την περιοχή σας",
  "requests": {
    "title": "Αιτήματα",
    "count": "{{count}} αίτημα(τα)",
    "empty": {
      "noListingDescription": "Δεν έχετε ακόμα καταχώρηση. Δημοσιεύστε μία για να λάβετε αιτήματα."
    },
    "loading": "Φόρτωση αιτημάτων...",
    "errors": {
      "notAuthenticated": "Πρέπει να συνδεθείτε για να δείτε αυτήν τη σελίδα.",
      "loadFailed": "Παρουσιάστηκε σφάλμα κατά τη φόρτωση των αιτημάτων."
    },
    "defaultPropertyType": "Κατάλυμα",
    "sortOptions": {
      "recent": "Το πιο πρόσφατο",
      "rating": "Καλύτερη βαθμολογία",
      "distance": "Plus proches"
    }
  },
  "aiSection": {
    "title": "Έξυπνες προτάσεις",
    "subtitle": "Ανακαλύψτε τα μέλη που ταιριάζουν με τα κριτήριά σας",
    "distance": "Απόσταση",
    "dates": "Ημερομηνίες",
    "guests": "Ταξιδιώτες",
    "matchScore": "Βαθμολογία συμβατότητας",
    "search": "Αναζήτηση",
    "startDiscussion": "Έναρξη συζήτησης",
    "viewProfile": "Προβολή προφίλ",
    "away": "απόσταση"
  }
};
